// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2y-9d","balanceDisclaimer":"posDashboard_balanceDisclaimer__34yRt"};